<template>
  <section class="c-facilities">
    <h3 class="c-facilities__header">
      Fasiliteter
    </h3>
    <ul class="c-facilities__list">
      <li
        v-for="facility in facilities"
        :key="facility.name"
        class="c-facilities__item"
      >
        {{ facility.name }}
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'Facilities',
  props: {
    facilities: {
      required: true,
      type: Array,
    },
  },
};
</script>